import { PointsAuditEventType } from '@shared/enums';
import { TFunction } from 'i18next';

/** A Record, so a new event type fails to compile until it has a label. */
const LABELS: Record<PointsAuditEventType, (t: TFunction) => string> = {
  [PointsAuditEventType.AccountsLinked]: (t) => t($ => $.pointsAudit.eventTypes.accountsLinked),
  [PointsAuditEventType.AccountsUnlinked]: (t) => t($ => $.pointsAudit.eventTypes.accountsUnlinked),
  [PointsAuditEventType.BehaviorCompleted]: (t) => (
    t($ => $.pointsAudit.eventTypes.behaviorCompleted)
  ),
  [PointsAuditEventType.BehaviorReversed]: (t) => t($ => $.pointsAudit.eventTypes.behaviorReversed),
  [PointsAuditEventType.BookingPointsReturned]: (t) => (
    t($ => $.pointsAudit.eventTypes.bookingPointsReturned)
  ),
  [PointsAuditEventType.CategoryMappingChanged]: (t) => (
    t($ => $.pointsAudit.eventTypes.categoryMappingChanged)
  ),
  [PointsAuditEventType.ExclusionChanged]: (t) => t($ => $.pointsAudit.eventTypes.exclusionChanged),
  [PointsAuditEventType.ImportCompleted]: (t) => t($ => $.pointsAudit.eventTypes.importCompleted),
  [PointsAuditEventType.ImportDiscarded]: (t) => t($ => $.pointsAudit.eventTypes.importDiscarded),
  [PointsAuditEventType.ManualPointsAdjusted]: (t) => (
    t($ => $.pointsAudit.eventTypes.manualPointsAdjusted)
  ),
  [PointsAuditEventType.ManualPointsEdited]: (t) => (
    t($ => $.pointsAudit.eventTypes.manualPointsEdited)
  ),
  [PointsAuditEventType.MembershipChanged]: (t) => (
    t($ => $.pointsAudit.eventTypes.membershipChanged)
  ),
  [PointsAuditEventType.PointsExpirationChanged]: (t) => (
    t($ => $.pointsAudit.eventTypes.pointsExpirationChanged)
  ),
  [PointsAuditEventType.PointsImported]: (t) => t($ => $.pointsAudit.eventTypes.pointsImported),
  [PointsAuditEventType.ProductExclusionChanged]: (t) => (
    t($ => $.pointsAudit.eventTypes.productExclusionChanged)
  ),
  [PointsAuditEventType.ProgramSettingsChanged]: (t) => (
    t($ => $.pointsAudit.eventTypes.programSettingsChanged)
  ),
  [PointsAuditEventType.PromotionCreated]: (t) => t($ => $.pointsAudit.eventTypes.promotionCreated),
  [PointsAuditEventType.PromotionDeleted]: (t) => t($ => $.pointsAudit.eventTypes.promotionDeleted),
  [PointsAuditEventType.PromotionEdited]: (t) => t($ => $.pointsAudit.eventTypes.promotionEdited),
  [PointsAuditEventType.RecalculationQueued]: (t) => (
    t($ => $.pointsAudit.eventTypes.recalculationQueued)
  ),
  [PointsAuditEventType.Revert]: (t) => t($ => $.pointsAudit.eventTypes.revert),
  [PointsAuditEventType.SyncCompleted]: (t) => t($ => $.pointsAudit.eventTypes.syncCompleted),
  [PointsAuditEventType.TierOverrideSet]: (t) => t($ => $.pointsAudit.eventTypes.tierOverrideSet),
};

export const eventTypeLabel = (eventType: PointsAuditEventType, t: TFunction): string => (
  LABELS[eventType]?.(t) ?? eventType
);
